module.exports = __webpack_public_path__ + "media/react/assets/Subgoal-a226625643f3e07a880dbe795758a7ac.svg";